import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Send } from "lucide-react";

const SUGGESTIONS = [
  "Have we ever installed standing seam metal roofing?",
  "Show every project over $2 million.",
  "Find every VA project we've completed.",
  "Which proposals used past performance in Georgia?",
];

export default function KnowledgeBase() {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [messages, setMessages] = useState([]);

  const ask = async (text) => {
    const question = text || q;
    if (!question.trim()) return;
    setMessages(m => [...m, { role: "user", content: question }]);
    setQ(""); setBusy(true);
    try {
      const r = await api.post("/knowledge/ask", { question });
      setMessages(m => [...m, { role: "ai", content: r.data.answer, sources: r.data.sources_count }]);
    } catch (e) {
      toast.error("AI error");
    } finally { setBusy(false); }
  };

  return (
    <div className="p-8 stagger-in max-w-4xl" data-testid="knowledge-page">
      <div className="mb-8">
        <div className="mono-label text-cyan-400 mb-2">// KNOWLEDGE BASE</div>
        <h1 className="font-display font-black text-4xl tracking-tight">Ask your company data</h1>
        <p className="text-slate-400 mt-2">Natural-language search over every document, proposal, and past project.</p>
      </div>

      <div className="bg-[#0D1424] border border-white/10 min-h-[500px] p-6 mb-4">
        {messages.length === 0 && (
          <div className="text-center py-10">
            <Sparkles className="w-10 h-10 text-cyan-400 mx-auto mb-4" strokeWidth={1.5} />
            <div className="text-slate-400 mb-6">Ask anything about your company's past work.</div>
            <div className="flex flex-wrap gap-2 justify-center">
              {SUGGESTIONS.map(s => (
                <button key={s} onClick={() => ask(s)} className="text-sm border border-white/10 hover:border-cyan-400 hover:text-cyan-400 transition-colors px-3 py-2" data-testid={`suggest-${s.substring(0, 10)}`}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`mb-6 ${m.role === "user" ? "" : ""}`}>
            <div className="mono-label mb-2 flex items-center gap-2">
              {m.role === "user" ? <span className="text-slate-500">YOU</span> : <span className="text-cyan-400 flex items-center gap-1"><Sparkles className="w-3 h-3" />BIDFORGE AI</span>}
              {m.sources !== undefined && <span className="text-slate-500">· {m.sources} docs</span>}
            </div>
            <div className={`p-4 border ${m.role === "user" ? "border-white/10 bg-white/[0.02]" : "border-cyan-400/20 bg-cyan-400/[0.03]"} text-slate-200 whitespace-pre-wrap text-sm leading-relaxed`}>{m.content}</div>
          </div>
        ))}
        {busy && <div className="mono-label text-cyan-400 animate-pulse">◉ THINKING…</div>}
      </div>

      <form onSubmit={(e) => { e.preventDefault(); ask(); }} className="flex gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ask a question…" className="flex-1 bg-[#0D1424] border border-white/10 focus:border-cyan-400 px-4 py-3 outline-none transition-colors" data-testid="kb-input" />
        <button type="submit" disabled={busy || !q} className="bg-cyan-400 text-[#070B14] px-5 mono-label hover:bg-cyan-300 disabled:opacity-50 flex items-center gap-2" data-testid="kb-submit">
          <Send className="w-4 h-4" />ASK
        </button>
      </form>
    </div>
  );
}
